'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export const GoogleTagProvider = () => {
	const pathname = usePathname();

	useEffect(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'page_view',
			page: window.location.href,
		});
	}, [pathname]);

	return null;
};
